export const placeholders = {
  generalMenu: "generalMenu",
  leftMenu: "leftMenu",
  tabMenu: "tabMenu",
  projectTabMenu: "projectTabMenu",
  projectSubMenu: "projectSubMenu",
};
